import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="master-search"
export default class extends Controller {
  static targets = ["searchInput", "results", "resultsContent", "loading"]
  static values = { 
    url: String,
    errorTitle: String,
    errorMessage: String
  }

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  search() {
    const searchTerm = this.searchInputTarget.value.trim()
    
    // Clear previous timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Hide results if search query is empty
    if (searchTerm.length === 0) {
      this.hideResults()
      return
    }

    // Show loading indicator after small delay
    this.debounceTimer = setTimeout(() => {
      this.performSearch(searchTerm)
    }, 300)
  }

  async performSearch(searchTerm) {
    try {
      this.showLoading()
      
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set('search', searchTerm)
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.showResults(data.html)
      
    } catch (error) {
      console.error('Master search error:', error)
      this.showError()
    }
  }

  showLoading() {
    this.loadingTarget.classList.remove('d-none')
    this.resultsTarget.classList.add('d-none')
  }

  showResults(html) {
    this.loadingTarget.classList.add('d-none')
    this.resultsContentTarget.innerHTML = html
    this.resultsTarget.classList.remove('d-none')
  }

  hideResults() {
    this.loadingTarget.classList.add('d-none')
    this.resultsTarget.classList.add('d-none')
    this.resultsContentTarget.innerHTML = ''
  }

  showError() {
    this.loadingTarget.classList.add('d-none')
    this.resultsContentTarget.innerHTML = `
      <div class="text-center py-4">
        <i class="fa-solid fa-exclamation-triangle fa-3x text-danger mb-3"></i>
        <h6 class="text-danger">${this.errorTitleValue}</h6>
        <p class="text-muted small mb-0">${this.errorMessageValue}</p>
      </div>
    `
    this.resultsTarget.classList.remove('d-none')
  }
}